import type { SVGProps } from "react";

/**
 * loading-circle, quarter, spinner
 * @category Interface General
 */
export default function IconLoadingCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z'
        stroke='currentColor'
        strokeOpacity='0.3'
        strokeWidth='1.5'
      />
      <path
        d='M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
}
